<template>

  <Fields :disabled="disabled" @setRevision="setRevision" v-if="editable_rules" :rules="editable_rules"
    :measurement_type_id="measurement_type_id" @updateFields="setFields" :inspection_id="inspection_id"
    :revision_info="revision_info" :measurement_revisions="measurement_revisions"></Fields>

  <template v-if="editable_rules && $store.getters.getInspectionMethodCode == 'IB22'">

    <ion-list :inset="true" class="mt-2">
      <ion-item :disabled="disabled" lines="inset" v-if="editable_rules.conditional_statements[0].data.length != 0">
        <ion-label>Resultaat handmatig aanpassen</ion-label>
        <ion-toggle :readonly="disabled" slot="end" v-model="editable_rules.set_manually"></ion-toggle>
      </ion-item>

      <transition name="level">
        <ion-item :disabled="disabled" lines="inset" v-if="editable_rules.set_manually">
          <ion-label>Kies een resultaat</ion-label>
          <ion-select :readonly="disabled" mode="ios" okText="Kies" cancelText="Annuleren"
            v-model="editable_rules.result" :options="calculator.output_values">
            <ion-select-option :value="option.value" v-for="(option, index) in calculator.output_values" :key="index">
              {{ option.label }}</ion-select-option>
          </ion-select>
        </ion-item>

      </transition>
    </ion-list>
  </template>
</template>

<script>
import Fields from "./Fields";
import { db } from '@/services/db'
import { save } from 'ionicons/icons';
import calculator from "@/services/measurement_calculator";

export default {
  name: "measurements-calculator",
  props: ["horizontal", "location_item_component_uuid", "disabled", "measurement_type_id", "inspection_id", "rules"],
  components: { Fields, },
  emits: ["result"],
  data() {
    return {
      calculator: calculator,
      save,
      location_item_component: {
        name: null
      },
      editable_rules: null,
      measurement_revisions: [],
      revision_info: null
    };
  },
  created() {
    this.setup()
  },
  methods: {
    async setRevision(revision) {
      this.editable_rules = revision.rules;
      calculator.calculate(this.editable_rules)
      this.revision_info = `Rev. ${revision.revision} - ${new Date(revision.created_at).toLocaleDateString()}`
    },
    setFields(fields) {
      this.editable_rules.fields = fields
      calculator.calculate(this.editable_rules)
    },
    async setup() {
      let measurement_type_revision;
      
      // Check if existing measurement has a stored revision_id
      if (this.rules && this.rules.revision_id) {
        // Use the stored revision_id to get the exact revision
        measurement_type_revision = await db.measurement_type_revisions.where('id').equals(this.rules.revision_id).first();
      }
      
      // If no stored revision or not found, fall back to inspection's current revision
      if (!measurement_type_revision) {
        const inspection = await db.inspections.where({ id: parseInt(this.$store.getters.getInspectionId) }).first();
        const measurement_type_revision_ids = inspection.measurement_type_revisions.map(revision => revision.id);
        const measurement_type_revisions = await db.measurement_type_revisions.where('id').anyOf(measurement_type_revision_ids).toArray();
        measurement_type_revision = measurement_type_revisions.find(revision => revision.measurement_type_id == this.measurement_type_id);
      }

      // if we have no measurement_type_revision, return
      if (!measurement_type_revision) return;

      // if it an existing measurement, we set the rules
      if (this.rules) {
        this.editable_rules = this.rules
        calculator.calculate(this.rules)
      } else {
        this.editable_rules = measurement_type_revision.rules;
      }

      this.revision_info = `Rev. ${measurement_type_revision.revision} - ${new Date(measurement_type_revision.created_at).toLocaleDateString()}`;

      if (this.location_item_component_uuid) {
        this.location_item_component = await db.location_item_components.get(this.location_item_component_uuid)
      }
    },
    setManually() {
      this.editable_rules.set_manually = true;
    },

  },
  watch: {
    "editable_rules.set_manually": function (value) {
      if (!value) {
        this.setup()
      }
    },
  }

};
</script>

<style></style>
